module.exports = __webpack_public_path__ + "static/media/Rec-3.4e065471.jpg";